import TextAnimated from './text-animated/script';
import TextExperienceDetailIntro from './text-experience-detail-intro/script';
import TextParallax from './text-parallax/script';

export default {
	[TextAnimated.selector]: TextAnimated,
	[TextExperienceDetailIntro.selector]: TextExperienceDetailIntro,
	[TextParallax.selector]: TextParallax
};
